// extracted by mini-css-extract-plugin
export var btn = "J_mY p_rF p_rg d_bz d_bP d_bD d_dw";
export var full = "J_wJ d_w d_H";
export var hoverStyle = "J_m1";
export var zoom = "J_m2";